import { useEffect, useState } from 'react';
import { CChart } from '@coreui/react-chartjs';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';

const GraphData = ({ statsType, data = null }: any) => {

    if (!data) {
        return null;
    }

    return (
        <>
            <div>
                <Row>

                    <Col md={12}>
                        <div className='line_chart_admin border_background'>
                            <CChart
                                type="line"

                                data={{
                                    labels: data?.labels,
                                    datasets: [
                                        {
                                            label: "Doctors",
                                            backgroundColor: "#1199DE",
                                            borderColor: "#1199DE",
                                            pointBackgroundColor: "#1199DE",
                                            pointBorderColor: "#fff",
                                            data: data.doctorData,
                                        },
                                        {
                                            label: "Patients",
                                            backgroundColor: "rgba(1, 1, 1, 0.84)",
                                            borderColor: "rgba(1, 1, 1, 0.84)",
                                            pointBackgroundColor: "rgba(1, 1, 1, 1)",
                                            pointBorderColor: "#fff",
                                            data: data.patientData
                                        },
                                        {
                                            label: "Appointments",
                                            backgroundColor: "rgba(109, 187, 60, 0.84)",
                                            borderColor: "rgba(109, 187, 60, 0.84)",
                                            pointBackgroundColor: "rgba(109, 187, 60, 0.84)",
                                            pointBorderColor: "#fff",
                                            data: data.appointmentData
                                        },
                                    ],
                                }}
                            />
                        </div>

                    </Col>

                </Row>


            </div>
        </>
    )
}

export default GraphData;